// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Container */
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f7fafc;
  }
  
  /* Form Styling */
  .login-form {
    width: 100%;
    max-width: 400px;
    padding: 2rem;
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  /* Input and Button Fields */
  .input-group {
    margin-bottom: 1rem;
  }
  
  .input-field {
    width: 100%; /* Ensures full width */
    padding: 0.75rem;
    font-size: 1rem;
    color: #1a202c;
    background-color: #edf2f7;
    border: 1px solid #ccc;
    border-radius: 0.375rem;
    transition: all 0.2s ease;
    box-sizing: border-box; /* Ensures padding and border are included in width */

  }
  
  .input-field:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(65, 148, 69, 0.2);
  }
  
  /* Submit Button */
  .submit-button {
    display: flex;
    justify-content: center;
    width: 100%; /* Ensures full width */
    padding: 0.75rem;
    font-size: 1rem;
    font-weight: medium;
    color: white;
    background-color: var(--primary-color);
    border: none;
    border-radius: 0.375rem;
    transition: background-color 0.2s;
  }
  
  .submit-button:hover {
    background-color: var(--primary-color);
  }
  
  .submit-button:focus {
    outline: none;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/login/login.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA,iBAAiB;EACjB;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,wCAAwC;EAC1C;;EAEA,4BAA4B;EAC5B;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW,EAAE,uBAAuB;IACpC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB,EAAE,qDAAqD;;EAE/E;;EAEA;IACE,aAAa;IACb,kCAAkC;IAClC,4CAA4C;EAC9C;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW,EAAE,uBAAuB;IACpC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,sCAAsC;IACtC,YAAY;IACZ,uBAAuB;IACvB,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,aAAa;EACf","sourcesContent":["/* General Container */\n.login-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    background-color: #f7fafc;\n  }\n  \n  /* Form Styling */\n  .login-form {\n    width: 100%;\n    max-width: 400px;\n    padding: 2rem;\n    background-color: white;\n    border-radius: 0.5rem;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  /* Input and Button Fields */\n  .input-group {\n    margin-bottom: 1rem;\n  }\n  \n  .input-field {\n    width: 100%; /* Ensures full width */\n    padding: 0.75rem;\n    font-size: 1rem;\n    color: #1a202c;\n    background-color: #edf2f7;\n    border: 1px solid #ccc;\n    border-radius: 0.375rem;\n    transition: all 0.2s ease;\n    box-sizing: border-box; /* Ensures padding and border are included in width */\n\n  }\n  \n  .input-field:focus {\n    outline: none;\n    border-color: var(--primary-color);\n    box-shadow: 0 0 0 2px rgba(65, 148, 69, 0.2);\n  }\n  \n  /* Submit Button */\n  .submit-button {\n    display: flex;\n    justify-content: center;\n    width: 100%; /* Ensures full width */\n    padding: 0.75rem;\n    font-size: 1rem;\n    font-weight: medium;\n    color: white;\n    background-color: var(--primary-color);\n    border: none;\n    border-radius: 0.375rem;\n    transition: background-color 0.2s;\n  }\n  \n  .submit-button:hover {\n    background-color: var(--primary-color);\n  }\n  \n  .submit-button:focus {\n    outline: none;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
